import type { OrganizationInfoWrapperProps } from "./organization-info.type";

import { useGetOrganization } from "@/entities/organization";
import FetchItemWrapper from "@/modules/fetch-item-wrapper";

import { OrganizationInfo } from "./organization-info.component";

export const OrganizationInfoWrapper = ({
  organizationId,
}: OrganizationInfoWrapperProps) => {
  const { organization, isLoading } = useGetOrganization(organizationId);

  return (
    <FetchItemWrapper
      item={organization}
      loading={isLoading}
      renderContent={(organization) => (
        <OrganizationInfo organization={organization} />
      )}
    />
  );
};
